import { IDropzoneUploaderFile } from "component-library";
import {
  IAboutYouFormInformationModel,
  IAboutYouFormPhotoModel,
  IMainAndYPFormInformationModel,
} from "../../../../../../formModels/AboutYouFormModel";
import { removeTimezoneOffset } from "../../../../../../helpers/date-helpers";
import {
  CUSTOM_FACET_ID,
  NON_BINARY_FACET_ID,
} from "../../../../../../hooks/useAdditionalGenderOptions";
import {
  IBooleanValueBEModel,
  ISaveAboutYouInformationRequestMainPerf,
  ISaveAboutYouInformationRequestYP,
} from "../../../../../../services/user-account-service.types";
import { IUploadHeadshotRequest } from "../../../../../../services/webmedia-service.types";

export const mapHeadshotDataToBEModel = (
  data: IAboutYouFormPhotoModel
): IUploadHeadshotRequest => {
  const photo = (data.photo as IDropzoneUploaderFile[])[0];

  return {
    photo: photo.file,
    photographerName: data.photographerName,
  };
};

export const mapAboutYouDataToBEModel = (
  data: IAboutYouFormInformationModel | IMainAndYPFormInformationModel,
  isYP?: boolean
):
  | ISaveAboutYouInformationRequestYP
  | ISaveAboutYouInformationRequestMainPerf => {
  const isCurrentMember = data.currentMember === "yes";

  const customGenderOptionsRequired =
    data.gender === NON_BINARY_FACET_ID || data.gender === CUSTOM_FACET_ID;

  let customOrNonBinaryGender: number | undefined;

  if (customGenderOptionsRequired && data.customOrNonBinaryGender) {
    customOrNonBinaryGender = parseInt(`${data.customOrNonBinaryGender}`);
  }

  const commonValues: ISaveAboutYouInformationRequestYP = {
    publishAge: data.publishAge,
    playingAgeFrom: data.playingAgeFrom as number,
    playingAgeTo: data.playingAgeTo as number,
    findMeAs: data.gender as number,
    customOrNonBinaryGender,
    showGenderOnProfile: data.showGenderOnProfile ? "yes" : "no",
    deafOrDisabled: data.deafOrDisabled,
    furtherInformation: data.furtherInformation,
    address: {
      street1: data.street1,
      street2: data.street2,
      city: data.city,
      country: data.country,
      state_province: data.state_province,
      postal_code: data.postal_code,
    },
    currentMember: data.currentMember as IBooleanValueBEModel,
    currentEmail: isCurrentMember ? data.currentEmail : undefined,
    currentName: isCurrentMember ? data.currentName : undefined,
    currentPerformerType: isCurrentMember
      ? data.currentPerformerType || undefined
      : undefined,
  };

  return isYP
    ? commonValues
    : {
        ...commonValues,
        mobileNumber: (data as IMainAndYPFormInformationModel).mobileNumber,
        landlineNumber: (data as IMainAndYPFormInformationModel).landlineNumber,
        dateOfBirth: removeTimezoneOffset(
          (data as IMainAndYPFormInformationModel).dateOfBirth
        ) as Date,
        membershipOptions: (data as IMainAndYPFormInformationModel)
          .membershipOptions,
        agents: (data as IMainAndYPFormInformationModel).agents,
      };
};
